// Google Analytics service for FuelHunt
// Tracks user interactions and location searches

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

/**
 * Check if Google Analytics is available and we're not in development mode
 */
const isAnalyticsEnabled = (): boolean => {
  return typeof window !== 'undefined' && 
         typeof window.gtag === 'function' && 
         import.meta.env.PROD;
};

/**
 * Track when a user searches for a location
 * This captures postcodes, city names, and any location input
 */
export const trackLocationSearch = (searchTerm: string): void => {
  if (!isAnalyticsEnabled()) return;
  
  try {
    window.gtag('event', 'location_search', {
      event_category: 'user_interaction',
      event_label: searchTerm,
      search_term: searchTerm
    });
  } catch (error) {
    console.warn('Analytics tracking failed:', error);
  }
};

/**
 * Track when a user uses their current location
 */
export const trackCurrentLocationUsed = (): void => {
  if (!isAnalyticsEnabled()) return;
  
  try {
    window.gtag('event', 'current_location_used', {
      event_category: 'user_interaction',
      event_label: 'geolocation'
    });
  } catch (error) {
    console.warn('Analytics tracking failed:', error);
  }
};

/**
 * Track general page views (automatically handled by GA4, but can be used for SPA navigation)
 */
export const trackPageView = (pageTitle?: string): void => {
  if (!isAnalyticsEnabled()) return;
  
  try {
    window.gtag('config', 'G-QSWS6H87EN', {
      page_title: pageTitle || document.title,
      page_location: window.location.href
    });
  } catch (error) {
    console.warn('Analytics tracking failed:', error);
  }
};